import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

export const getProductBrands = async () => {
  const response = await axiosInstance.get('ProductBrand/get-brands');
  return response.data;
};

export const getProductBrandById = async (brandId) => {
  const response = await axiosInstance.get(`ProductBrand/get-brand/${brandId}`);
  return response.data;
};

export const searchProductBrands = async (name) => {
  const response = await axiosInstance.get('ProductBrand/search', { 
    params: { name } 
  });
  return response.data;
};

export const addProductBrand = async (brandData) => {
  const response = await axiosInstance.post('ProductBrand/add-brand', brandData);
  return response.data;
};

export const updateProductBrand = async (brandData) => {
  const response = await axiosInstance.post('ProductBrand/update-brand', brandData);
  return response.data;
};

export const deleteProductBrand = async (brandId) => {
  const response = await axiosInstance.delete(`ProductBrand/delete-brand/${brandId}`);
  return response.data;
};